<template>
<div>
  <div>
    <span>{{completion.optionContent}}</span>
  </div>

  <div class="form-input">
    <label class="labelStyle" style="width: 100px;">现场监测值:</label>
    <input
      v-model="completion.theoryValue"
      type="number"
      class="input"
      @input="onInput"
    />
  </div>
  <div class="form-input">
    <label class="labelStyle" style="width: 100px;">质控设备监测值:</label>
    <input
      v-model="completion.value"
      type="number"
      class="input"
      @input="onInput"
    />
  </div>
  <div class="form-input">
    <label>偏差:</label>
    <span
      v-if="isCompleted"
      :style="{color: isQualified ? 'green' : 'red'}"
      class="diff"
    >{{(completion.resultValue * 100).toFixed(2)}}%</span>
    <span v-else class="diff">--</span>
  </div>
</div>
</template>

<script>
import BaseFormula from '../BaseFormula'

export default {
  name: 'NOyAccuracy',
  extends: BaseFormula,
  getSelected: opt => `设定值:${opt.theoryValue}, 实测值:${opt.value}`,
  computed: {
    theoryValue () {
      let theoryValue = this.completion.theoryValue
      return typeof theoryValue === 'number' ? theoryValue : (theoryValue ? Number(theoryValue) : null)
    },
    realValue () {
      let realValue = this.completion.value
      return typeof realValue === 'number' ? realValue : (realValue ? Number(realValue) : null)
    },
    threshold () {
      return this.completion.threshold
    },
    isCompleted () {
      return typeof this.theoryValue === 'number' && typeof this.realValue === 'number'
    },
    isQualified () {
      let {resultValue} = this.completion
      return this.compare(Math.abs(resultValue), 0.1) ? 1 : (this.compare(Math.abs(resultValue), this.threshold) ? 0.5 : 0)
    }
  },
  methods: {
    setParam () {
      let completion = this.completion
      completion.isCompleted = this.isCompleted
      completion.isQualified = this.isQualified
    },
    onInput () {
      let {theoryValue, realValue} = this
      this.completion.resultValue = Number(((realValue - theoryValue) / theoryValue).toFixed(7))
      this.setParam()
      this.$emit('complete-change')
    }
  },
  created () {
    this.setParam()
  }
}
</script>

<style lang="scss" scoped>
.form-input {
  margin-top: 5px;
}

.input {
  margin-left: 10px;
}

.diff {
  margin-left: 22px;
}

.labelStyle {
  display:inline-block;
  text-align: justify;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/Formula/NOyAccuracy.vue